import React from "react"
import DefaultAvatar from "../../../../assets/img/user-placeholder.svg"

const Employee = props => {
  const { first_name: firstName, last_name: lastName, email, avatar } = props

  let identifier = firstName
  if (firstName) {
    identifier += " "
    identifier += lastName
  } else {
    identifier = email
  }

  return (
    <div className="col-xs-6 col-sm-4 col-md-2 gl-analytics__employee mb-5 text-color">
      <img
        alt=""
        src={avatar.url || DefaultAvatar}
        className="gl-user-avatar gl-user-avatar--plain gl-user-avatar--small mb-5"
      />
      <p className="gl-small-title-size text-center">{identifier}</p>
    </div>
  )
}

const Contributors = ({ group }) => {
  return (
    <div>
      <div className="text-color font-light flex items-center mb-5 justify-end">
        <p className="gl-title-size">
          {group.employees.length} jogadores selecionados
        </p>
      </div>
      <div className="row">
        {group.employees.map(e => (
          <Employee key={`employee-${e.id}`} {...e} />
        ))}
      </div>
    </div>
  )
}

export default Contributors
